"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroEventListResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const enums_1 = require("../../enums");
class HeroEventListResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'name',
            'eventCategory',
            'startTime',
            'recurrence',
            'nextScheduledHeroEvent',
            'nextScheduledHeroEventId',
            'active'
        ];
    }
    id;
    name;
    eventCategory;
    startTime;
    recurrence;
    nextScheduledHeroEventTimestamp;
    nextScheduledHeroEventId;
    active;
    static mapHeroEventListResponseDto(entities) {
        return entities.map((entity) => {
            const response = new HeroEventListResponseDto();
            response.mapFields(entity);
            response.eventCategory = entity['eventCategory'].name;
            if (entity['scheduledHeroEvents'] &&
                entity['scheduledHeroEvents'].length > 0) {
                //   sortScheduledHeroEvent by calendarDay
                const sortedScheduledHeroEvents = entity['scheduledHeroEvents']
                    .filter((scheduledHeroEvent) => {
                    const today = new Date();
                    // set today to the morning
                    today.setHours(0, 0, 0, 0);
                    return scheduledHeroEvent.calendarDay.date > today;
                })
                    .sort((a, b) => a.calendarDay.date - b.calendarDay.date);
                const nextScheduledHeroEvent = sortedScheduledHeroEvents[0];
                if (nextScheduledHeroEvent) {
                    response.nextScheduledHeroEventTimestamp =
                        nextScheduledHeroEvent.calendarDay.date.getTime();
                    response.nextScheduledHeroEventId = nextScheduledHeroEvent.id;
                }
            }
            return response;
        });
    }
}
exports.HeroEventListResponseDto = HeroEventListResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventListResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventListResponseDto.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventListResponseDto.prototype, "eventCategory", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventListResponseDto.prototype, "startTime", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], HeroEventListResponseDto.prototype, "recurrence", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventListResponseDto.prototype, "nextScheduledHeroEventTimestamp", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], HeroEventListResponseDto.prototype, "nextScheduledHeroEventId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], HeroEventListResponseDto.prototype, "active", void 0);
